import React from 'react';
import Grid from '@material-ui/core/Grid'
import {AutocompleteInput, ReferenceInput, required, TextInput} from 'react-admin';

const TeacherClazzFieldsDialog = ({classes, ...props}) => {
    return (
        <React.Fragment>
            <Grid item xs={12} sm={6}>
                <TextInput source="subject" validate={required()} {...props} />
            </Grid>
            <Grid item xs={12} sm={6}>
                <ReferenceInput source="customerId" reference="customers"
                                filter={{employeeOnly: true}}
                                sort={{field: 'name', order: 'ASC'}}
                                perPage={30}
                                validate={required()} {...props} >
                    <AutocompleteInput optionText="displayName"/>
                </ReferenceInput>
            </Grid>
            <TextInput source="unitId" validate={required()} {...props} style={{display: 'none'}}/>
        </React.Fragment>
    )
}
export default TeacherClazzFieldsDialog;
